<template>
<div class="MLookReport">
    <div class="MCourseReportPrview_warp">
        <div class="content_box">
            <pdf v-for="item in pageCount" :key="item" :src="reportUrl" :page="item" />
        </div>
    </div>
    <img @click="toPage()" class="download_img" :src="require('@/common/images/gujingimgs/download.png')" alt="">
</div>
</template>

<script>
import {getReportUrl} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
import pdf from 'vue-pdf'
export default {
    name: 'MLookReport',
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes' }
        ]
    },
    data() {
        return {
            reportUrl: '',
            reportUrl2: '',
            pageCount: '',
            isdownloadresult: 0
        }
    },
    mounted() {
        this.getReportUrl()
    },
    methods: {
        // 下载报告页面
        toPage() {
            if (this.isdownloadresult === 0) {
                this.$router.push({name: 'MDownloadReport', query: {'orderno': this.$route.query.orderno}})
            } else {
                // console.log(this.reportUrl2)
                window.open(this.reportUrl2)
            }
        },
        getReportUrl() {
            this.setLoading(true)
            let params = {
                orderno: this.$route.query.orderno
            }
            getReportUrl({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.reportUrl = data.data.sireporturl
                    this.reportUrl2 = data.data.sireporturl
                    this.isdownloadresult = data.data.isdownloadresult
                    this.reportUrl = pdf.createLoadingTask(this.reportUrl)
                    this.reportUrl.then(pdf => {
                        // console.log('pdf.numPages', pdf.numPages)
                        this.pageCount = pdf.numPages
                        this.setLoading(false)
                    })
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        pdf
    }
}
</script>

<style lang="scss" type="text/scss">
.MLookReport {
    width: 100vw;
    // height: 100vh;
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    overflow: hidden;
    background-color: rgb(255, 255, 255);
    .download_img {
        width: 1.16rem;
        height: 1.16rem;
        position: fixed;
        bottom: 1.2rem;
        right: 0.22rem;
    }
}
</style>